var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOctorionLeftPointer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 141,
    viewBox: "0 0 24 141",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(1 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 120)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 4.529,
    fill: "#BB2025"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 7.118,
    stroke: "#BB2025",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "#BB2025",
    opacity: 0.267
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#373D40",
    strokeDasharray: 4,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M-52.5,63.5 L75,64",
    transform: "rotate(-90 11 64)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOctorionLeftPointer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/octorion-left-pointer.a0a716d1.svg";
export { ForwardRef as ReactComponent };